import { useEffect, useState, useSyncExternalStore } from 'react';
import { deviceClass } from './pageContext';

const subscribeToResize = (onChange: () => void) => {
  window.addEventListener('resize', onChange);
  return () => window.removeEventListener('resize', onChange);
};

// On phones the launcher and opener cover the inline quote form, so they step aside while it is on screen.
export function useQuoteFormOnScreen(): boolean {
  const [formOnScreen, setFormOnScreen] = useState(false);
  // Re-read on resize: a page opened wide then narrowed (rotation, split screen) must still step aside.
  const isMobile = useSyncExternalStore(subscribeToResize, () => deviceClass() === 'mobile', () => false);

  useEffect(() => {
    const form = document.querySelector('[data-quote-form]');
    if (!form) return;
    const observer = new IntersectionObserver(([entry]) => setFormOnScreen(entry.isIntersecting));
    observer.observe(form);
    return () => observer.disconnect();
  }, []);

  return isMobile && formOnScreen;
}
